











































import {
    defineComponent,
    onMounted,
    onUnmounted,
    PropType,
    ref,
    Ref,
    toRefs,
    watch,
} from '@vue/composition-api';
import { Field, ZFormNode, ZRuleItem } from '@ks/z-form';
import InputUrl from '@/components/input/url.vue';
import {
    CallbackTaskStatus,
    callbackUrlTaskResult,
    createCallbackUrlTask,
    getGameInstruction,
    getInstruction,
} from '@api/controll';

export default defineComponent({
    components: {
        InputUrl,
        Field,
    },
    props: {
        node: {
            type: Object as PropType<
                ZFormNode<{
                    callbackUrl: string;
                    taskId: string;
                }>
            >,
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: '280',
        },
        type: {
            type: String,
            default: '',
        },
    },
    setup(props, ctx) {
        const inputWrap: Ref = ref(null);
        const callbackNode = props.node.node('callbackUrl');

        watch(callbackNode, (v: ZFormNode) => {
            const inputInner = inputWrap.value.$el.querySelectorAll(
                '.el-input__inner',
            ) as HTMLElement[];
            const inputSelect = inputInner[0];
            const input = inputInner[1];
            if (v.errorMessage) {
                input.classList.add('input-text-error');
                inputSelect.classList.add('input-text-error');
            } else {
                input.classList.remove('input-text-error');
                inputSelect.classList.remove('input-text-error');
            }
        });
        let latestTask = 0;
        onUnmounted(() => {
            latestTask = -1;
        });

        const rules: ZRuleItem[] = [
            {
                asyncValidator(_, value: string, cb: Function) {
                    if (!value) {
                        // eslint-disable-next-line no-undefined
                        cb(props.required ? '请输入地址' : undefined);
                        return;
                    }
                    const currentTask = ++latestTask;
                    let status = CallbackTaskStatus.不存在;
                    let taskId = '';
                    const checkResult = async () => {
                        const res = await callbackUrlTaskResult(
                            taskId,
                            ctx.root.$route.params.appId,
                        );
                        status = res.data.data.status;
                    };
                    const createTask = async () => {
                        const task = await createCallbackUrlTask(
                            value,
                            ctx.root.$route.params.appId,
                        );
                        taskId = task.data.data.taskId;
                        return checkResult();
                    };
                    const startValidate = () => {
                        setTimeout(async () => {
                            if (currentTask !== latestTask) return;
                            try {
                                switch (status) {
                                    case CallbackTaskStatus.不存在:
                                        await createTask();
                                        break;
                                    case CallbackTaskStatus.校验中:
                                        await checkResult();
                                        break;
                                    case CallbackTaskStatus.成功:
                                        props.node.value.taskId = taskId;
                                        cb();
                                        return;
                                    case CallbackTaskStatus.失败:
                                        cb('地址检测无效，请检查后重新输入。');
                                        return;
                                }
                                startValidate();
                            } catch (e) {
                                cb('校验失败');
                            }
                        }, 1000);
                    };
                    startValidate();
                },
            },
        ];

        const href = ref('');

        onMounted(() => {
            const getHref =
                props.type === 'game' ? getGameInstruction : getInstruction;
            getHref().then(
                (res) => {
                    href.value = res.data.data.instructionUrl;
                },
                () => {},
            );
        });

        return {
            rules,
            inputWrap,
            callbackNode,
            ...toRefs(callbackNode.error.required),
            href,
        };
    },
});
